$(document).on('click', ".dnJs-order-cancel", function (e) {
    e.preventDefault();

    var url = $(this).attr('data-url');
    var questionText = $(this).data('question');

    var r = confirm(questionText);
    if (r === true) {
        $.ajax({
            type: "POST",
            url: url,
            success: function (obj) {
                alert(obj.message) ? "" : location.reload();
            }
        });
    }
});
